import api from "./api"

export const fnGetBoards = async (cPanelId, cParams) => {
    const response = api.get(
        `/operational-panel/${cPanelId}/boards${cParams ? `?${cParams}` : ""}`,
    )
    return response
}
export const fnGetBoard = async (cPanelId, nBoardId) => {
    const response = await api.get(`operational-panel/${cPanelId}/boards?ids=${nBoardId}`)
    return response
}

export const fnCreateBoard = async (cPanelId, oParams) => {
    const response = api.post(`/operational-panel/${cPanelId}/boards`, oParams)
    return response
}
export const fnDeleteBoard = async (cPanelId, oParams) => {
    const response = api.delete(`/operational-panel-boards/${cPanelId}`, { data: oParams })
    return response
}
export const fnUpdateBoard = async (nPanelId, oData) => {
    const response = api.put(`/operational-panel-boards/${nPanelId}`, oData)
    return response
}

export const fnGetBoardInteractions = async (nBoardId) => {
    const response = api.get(`/operational-panel-boards-interactions/${nBoardId}`)
    return response
}
export const fnMoveBoard = async (oParams, nIdMove) => {
    const aNorms = oParams?.norms?.map((n) => n?.norm_nid)
    const aResponsibles = oParams?.responsibles?.map((r) => r?.user_nid)
    const aObservers = oParams?.observers?.map((o) => o?.user_nid)

    const response = await api.put(`/operational-panel-boards/${oParams?.id}`, {
        name: oParams.name,
        description: oParams.description,
        operational_panel_id: nIdMove,
        norms: aNorms,
        responsibles: aResponsibles,
        observers: aObservers,
    })
    return response
}

export const fnUpdateOrderBlocks = async (nBoardId, oData) => {
    const response = await api.patch(`/operational-panel-boards/${nBoardId}`, {
        blocks: oData,
    })
    return response
}

export const fnDuplicateBoard = async (nBoardId) => {
    const response = await api.post(`/operational-panel-boards/${nBoardId}/duplicate`)
    return response
}

export async function fnExportBoard(nBoarId, aFilters) {
    const response = api.get(
        `activity-block/${nBoarId}/export?&filters=${JSON.stringify(aFilters)}`,
    )
    return response
}

export async function fnPostExportBoard(nBoarId, bodyParms) {
    const response = await api.post(`/operational-panel-boards/${nBoarId}/export`, bodyParms, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    })
    return response.data
}

export async function fnGetBoardsModels() {
    const response = await api.get("/operational-panel-boards-models")
    return response
}


export async function fnCreateBoardFromModel(nPanelId, nModelId) {
    const response = await api.post(
        "/operational-panel/" + nPanelId + "/boards-models/" + nModelId,
    )
    return response
}

export async function fnSearchBoardsModels(cSearch) {
    const response = await api.get("/operational-panel-boards-models?search=" + cSearch)
    return response
}